<template>
  <div class="flex flex-column items-center">
    <img
      class="endpostimage"
      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/1.jpg"
    />

    <span class="endpagetext">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: require("../img/undraw-ednpage.png"),
    },
    text: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.endpostimage {
  width: 50%;
  margin-bottom: 10px;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  max-height: 30vh;
}

.endpagetext {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  font-weight: 600 !important;
  font-size: 20px !important;
}
</style>
